type Props = {
    rows?: number;
    columns: string[];
};

export default function TableSkeleton({ rows = 4, columns }: Props) {
    return (
        <div className="table-responsive" role="status" aria-live="polite">
            <table className="table table-sm table-bordered table-nowrap">
                <thead className="sticky-top">
                    <tr>
                        {columns.map((col, i) => (
                            <th key={i}>{col}</th>
                        ))}
                    </tr>
                </thead>
                <tbody aria-busy="true">
                    {Array.from({ length: rows }).map((_, i) => (
                        <tr key={i}>
                            {columns.map((_, j) => (
                                <td key={j} className="align-middle">
                                    <div className="skeleton-bg w-100" style={{ height: '16px', borderRadius: 4 }} />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
